// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__1aYto","title":"AfterImages45_title__1BiUL","images":"AfterImages45_images__30XRH"};